import React, { useContext } from 'react';
import classNames from 'classnames';
import { AudioSurah } from '@/infrastructure/class/audio-surah';
import s from './styles.module.scss';
import AudioSurahsListItemMenuBtn from '../../menu-btn';
import { Playlist } from '@/infrastructure/class/playlist';
import { useRouter } from 'next/router';
import { ReadSurahSlugsContext } from '@/infrastructure/context/read-surah-slugs-context';
import { getAudioSurahPath } from '@/infrastructure/functions/get-audio-surah-path';

interface IAudioSurahsListItemProps {
  data: AudioSurah;
  needTopBorder: boolean;
  partial: boolean;
  className?: string;
  playlist?: Playlist;
  reciterSlug?: string;
  onClick?: () => void;
}

const AudioSurahsListItem: React.FC<IAudioSurahsListItemProps> = (props) => {
  const {
    data,
    needTopBorder,
    partial,
    playlist,
    reciterSlug,
    className = '',
    onClick = () => {},
  } = props;

  const { getSurahSlugByNumber } = useContext(ReadSurahSlugsContext);

  const resolvedReciterSlug = reciterSlug ?? data.reciter?.slug;

  const route = getAudioSurahPath({
    reciterSlug: resolvedReciterSlug,
    surahNumber: data.number,
    getSurahSlugByNumber,
  });

  const router = useRouter();

  const readSurahsListItemClassNames = classNames(s['table-row'], className, {
    [s['border-top']]: needTopBorder,
  });

  const onItemClick = () => {
    onClick();
    if (!partial) {
      router.push(route);
    }
  };

  return (
    <tr className={readSurahsListItemClassNames}>
      <td>
        <div className={s['index']}>{data.number}</div>
      </td>
      <td className={s['title']}>
        <p className={s['link']} onClick={onItemClick}>
          {data.titleEn}
          <br />
          <span className={s['ar']}>{data.titleAr}</span>
        </p>
      </td>
      <td>
        <AudioSurahsListItemMenuBtn
          playlist={playlist}
          data={data}
          reciterSlug={resolvedReciterSlug}
        />
      </td>
    </tr>
  );
};

export default AudioSurahsListItem;
